import { render, staticRenderFns } from "./currentcard.vue?vue&type=template&id=2bd81890&scoped=true&"
import script from "./currentcard.vue?vue&type=script&lang=js&"
export * from "./currentcard.vue?vue&type=script&lang=js&"
import style0 from "./currentcard.vue?vue&type=style&index=0&id=2bd81890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd81890",
  null
  
)

export default component.exports